// @ts-nocheck
import React from 'react';
import _ from 'lodash';
import TaskComponent from 'react-scale/components/Task/TaskComponent';
import GlobalCSS from 'react-scale/components/legacy-css/global_css';
import LidarTaskPreview from '../LidarTaskPreview';
import { isContentAndLanguage } from '@scale/shared/defaults';
import transformLookupToAssignment from '@scale/shared/assignmentJson/transformLookupToAssignment';
import { SupplementedTaskPreviewAssignmentWrapper } from './SupplementedTaskPreviewAssignmentWrapper';
import { MultiTurnInteractionConfiguration } from '@scale/shared/types/chat';
import { TaskType } from '@scale/shared-types';

// response, given some piece of work
function fixResponseForResult(work) {
  if (work.__t === 'customeraudit') {
    return work.task.response;
  }
  if (work.taskAttempt) {
    return work.taskAttempt.response;
  }
  if (work.__t === 'task' && work.usesPipelineV3 && work.response) {
    return work.response;
  }
  if (isContentAndLanguage(work.type) && work.response) {
    return work.response;
  }

  const responsesRequired = (work.params && work.params.responses_required) || 1;
  const usesConsensus = responsesRequired > 1 && work.response;
  if (!usesConsensus && work.attempts && work.attempts.length > 0) {
    return work.attempts[work.attempts.length - 1].response;
  }

  return work.response;
}

function renderTask(currentTask, taskType, otherProps) {
  const taskProps = _.merge(currentTask, otherProps);

  return (
    <div className="TaskPreview">
      <GlobalCSS />
      <SupplementedTaskPreviewAssignmentWrapper
        assignment={taskProps.assignment}
        render={supplementedAssignment => (
          <TaskComponent
            taskType={taskType}
            taskProps={{ ...taskProps, assignment: supplementedAssignment }}
            compact={true}
          />
        )}
      />

      <style jsx global>{`
        .TaskPreview,
        .TaskPreview .task {
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          min-height: 0;
          overflow: auto;
        }
      `}</style>
    </div>
  );
}

// expects a normalized object
export default function TaskPreview({ object, config, response, extras = {} }) {
  if (!response) {
    response = fixResponseForResult(object);
  }

  // in the case of attempts, we grab subtask
  const taskOrSubtask = object.subtask || object;
  // HACK for a videoboxannotation task with video attachment, look at the subtask's image attachments and fall back to empty array
  if (taskOrSubtask.type === 'lidarannotation' || taskOrSubtask.type === 'lidarstitching') {
    return (
      <LidarTaskPreview object={taskOrSubtask} config={config} response={response} isPreviewMode />
    );
  }

  if (
    [TaskType.Chat, TaskType.TextCollection, TaskType.ChatV2].includes(taskOrSubtask.type) &&
    object.__t === 'taskattempt' &&
    !_.isNil(object.taskParamsFromV3Node)
  ) {
    (taskOrSubtask.params as unknown as MultiTurnInteractionConfiguration) =
      object.taskParamsFromV3Node;
  }

  if (taskOrSubtask.type === 'lidarsegmentation' || taskOrSubtask.type === 'sensorfusion') {
    return <div>Not supported yet</div>;
  }

  if (taskOrSubtask.type === 'videoboxannotation' && !taskOrSubtask.params.attachments) {
    taskOrSubtask.params.attachments =
      (object.subtasks && object.subtasks.length > 0 && object.subtasks[0].params.attachments) ||
      [];
  }

  const type = object.taskType || object.type;
  const assignment = transformLookupToAssignment(object);
  // I love .js files :)
  // TODO: Remove this? Move this to post-supplementation?
  if (assignment) {
    console.info(
      'Copy assignment.json to your clipboard: copy(JSON.stringify(assignment))',
      assignment,
    );
    window.assignment = assignment;
    return renderTask(taskOrSubtask, type, {
      config,
      assignment,
      fixResponse: object.status !== 'error' ? response : undefined,
      disableShortcuts: true,
      disableNavigationShortcuts: false,
      isReviewMode: true, // We should deprecate this. Preview !== Review
      isPreviewMode: true,
      readOnly: true,
      shouldShowContributorActions: !!extras.shouldShowContributorActions,
      transactionHistoryId: extras.transactionHistoryId,
    });
  }
  return null;
}
